import { render, staticRenderFns } from "./AlertMissedJobs.vue?vue&type=template&id=27b0deca&scoped=true&"
import script from "./AlertMissedJobs.vue?vue&type=script&lang=js&"
export * from "./AlertMissedJobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b0deca",
  null
  
)

export default component.exports